import React from "react";
import Button from 'react-bootstrap/Button';
import { useViewport } from 'components/general/useViewPort'
import { FontAwesomeIcon  } from "@fortawesome/react-fontawesome";
import {
  faThumbTack
} from "@fortawesome/free-solid-svg-icons";

const FavButton = ({ participant, favData, setFavData }) => {
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  const handleClick = (e) => {
    if (favData.includes(participant)){
      setFavData(favData.filter(e => e !== participant))
    } else{
      setFavData([...favData, participant])
    }
    
  }

  return (
    <Button variant="none" size={isMobile && "sm"} value="minus" onClick={handleClick} className={favData.includes(participant) && "glf-bg-fav-button"}>
      <FontAwesomeIcon className="font-icon" icon={faThumbTack} />
    </Button>
  )
}

export default FavButton;